// Parent product component, rendered via liquid (no templates)
if (!customElements.get('component-collection-filters')) {
  customElements.define('component-collection-filters', class CollectionFilters extends HTMLElement {
    constructor() {
      super();
      this.state = {
        selectedFilters: {},
        sortBy: '',
        filterLabelClicked: '',
      }
      this.props = {
        filterOrder: this.dataset.filterOrder,
        autoApplyAlphaSize: this.dataset.autoApplyAlphaSize === "true",
        autoApplyFormFitSize: this.dataset.autoApplyFormFitSize === "true",
        showUnderwearSize: this.dataset.showUnderwearSize === "true"
      }
    }
    connectedCallback() {
      this.querySelector('.js-filters-modal').classList.remove('hidden');
      this.addEventListener('update-state', event => {
        if (event && event.detail.paramName) {
          const options = [];
          for (let option in event.detail.options) {
            options.push(...event.detail.options[option]);
          }
          if (event.detail.type === 'Size') {
            if(event.detail.group) {
              if (event.detail.count === 0) {
                delete this.state.selectedFilters[event.detail.paramName][event.detail.group];
              } else {
                const uniqOptions = [... new Set(options)];
                this.state.selectedFilters[event.detail.paramName] = this.state.selectedFilters[event.detail.paramName] || {};
                this.state.selectedFilters[event.detail.paramName][event.detail.group] = {
                  options: uniqOptions,
                  type: event.detail.type,
                  count: uniqOptions.length
                }
              }
            }
          } else {
            this.state.selectedFilters[event.detail.paramName] = {
              options,
              type: event.detail.type,
              count: event.detail.count
            }
          }
        }
        if (event.detail.init) {
          this.renderSelectedFilters();
        }
      });
      this.addEventListener('remove-filter', (event) => {
        let options = [];
        let filterType = undefined;
        if (event && event.detail.paramName) {
          if (event.detail.paramName === 'filter.v.option.size') {
            let filterOptions = [];
            for (let sizeFilter in this.state.selectedFilters[event.detail.paramName]) {
              const sizeTypeOptions = this.state.selectedFilters[event.detail.paramName][sizeFilter].options;
              if (sizeTypeOptions[0] === event.detail.value) {
                  delete this.state.selectedFilters[event.detail.paramName][sizeFilter];
              } else {
                filterOptions = filterOptions.concat(sizeTypeOptions);
              }
            }
            options = [... new Set(filterOptions)];
            // If only bra is selected filter bra size options
            const sizeOptions = Object.keys(this.state.selectedFilters[event.detail.paramName]);
            if (sizeOptions.length === 1 && sizeOptions[0] === 'bra') {
              options = this.filterBraSizeOptions([... new Set(filterOptions)]);
            }
            filterType = 'Size';
          } else {
            options = this.state.selectedFilters[event.detail.paramName].options;
            filterType = this.state.selectedFilters[event.detail.paramName].type;
            options = options.filter(option => option !== event.detail.value);
            this.state.selectedFilters[event.detail.paramName].options = options;

            if (this.state.selectedFilters[event.detail.paramName].count > 0) {
              this.state.selectedFilters[event.detail.paramName].count--;
            }
          }
          if (filterType) {
            this.querySelector(`component-collection-filter[data-type="${filterType}"]`)?.uncheckSelectedValue(event.detail.value);
            this.querySelector(`component-collection-filter[data-type="${filterType}"]`)?.updateSelectedItemsText(options, filterType);
            this.filterProducts(false);
          }
        }
      });
      this.querySelectorAll('.js-clear-all').forEach(clear => {
        clear.addEventListener('click', () => {
          this.clearFilters();
          this.filterProducts(false);
        });
      });

      document.addEventListener("clean_filter_by_quiz_button", (event) => {
        this.clearFilters();
        this.filterProducts(false);
      });

      if (this.querySelector('.js-sort-by')) {
        this.querySelector('.js-sort-by').addEventListener('change', sortBy => {
          this.state.sortBy = sortBy.target.value;
          const params = this.getParams();
          this.renderCollectionGrid(params);
          this.sendSortByGTMData();
        });
      }

      this.querySelectorAll('.js-filter-label').forEach(label => {
        label.addEventListener('click', () => {
          this.toggleDrawer();
          this.querySelectorAll('component-collection-filter .js-filter-values').forEach(filter => filter.classList.add('hidden'));
          this.querySelector(`component-collection-filter[data-type="${label.dataset.type}"] .js-filter-accordion-btn`)?.click();
          this.state.filterLabelClicked = label.dataset.type || 'Filters';
        })
      });
      this.querySelector('.js-apply-btn').addEventListener('click', () => {
        this.filterProducts();
      });
      this.querySelector('.js-filters-modal-exit').addEventListener('click', () => {
        this.filterProducts();
      });
      this.querySelector('.js-filters-modal-overlay').addEventListener('click', () => {
        this.filterProducts();
      });
    }
    filterProducts(toggleDrawer = true) {
      const params = this.getParams();
      const searchUrl = decodeURIComponent(window.location.search.replace('?', ''));
      if (params !== searchUrl) {
        this.renderCollectionGrid(params);
        const totalCount = this.updateCount();
        this.toggleClear(totalCount);
      }
      if (toggleDrawer) this.toggleDrawer();
      this.renderSelectedFilters();
      this.sendFilterApplyGTMData();
    }
    async renderCollectionGrid(params) {
      // Uses shopify's section rendering api to rerender filtered grid via liquid
      try {
        const sectionId = this.getCurrentCollectionSectionId();
        const currentGrid = document.querySelector('.js-collection-grid');
        if (currentGrid) currentGrid.classList.add('hidden');
        document.dispatchEvent(new CustomEvent('show-collection-skeleton-loader'));
        const sectionQuery = sectionId || 'component-collection-grid';
        let grid = await fetch(`${window.location.pathname}?sections=${sectionQuery}${params ? '&' : ''}${params || ''}`);
        grid = await grid.json();
        const newUrl = `${window.location.pathname}?${params ? params : ''}`;
        window.history.replaceState({}, '', newUrl);
        const nextGridHtml = (sectionId && grid[sectionId]) || grid['component-collection-grid'];
        if (!nextGridHtml) throw new Error('Collection grid section response is empty');
        document.querySelector('.js-collection-grid-wrapper').innerHTML = nextGridHtml;
        document.dispatchEvent(new CustomEvent('hide-collection-skeleton-loader'));
      } catch (error) {
        const gridNode = document.querySelector('.js-collection-grid');
        if (gridNode) gridNode.classList.remove('hidden');
      }
    }
    getCurrentCollectionSectionId() {
      const sectionContainer = document.querySelector('.js-collection-grid-container');
      if (!sectionContainer) return '';
      const sectionClass = Array.from(sectionContainer.classList).find((className) => className.startsWith('section-'));
      return sectionClass ? sectionClass.replace('section-', '') : '';
    }
    toggleClear(totalCount) {
      if (totalCount > 0) {
        this.querySelectorAll('.js-clear-all').forEach(clear => clear.classList.remove('hidden'));
      } else {
        this.querySelectorAll('.js-clear-all').forEach(clear => clear.classList.add('hidden'));
      }
    }
    filterBraSizeOptions(options) {
      if (this.props.autoApplyAlphaSize) {
        options = options.filter(option => !Object.keys(getMappedAlphaSize()).includes(option));
      }
      if (this.props.autoApplyFormFitSize) {
        options = options.filter(option => {
          const decodedOption = decodeURIComponent(option);
          return !decodedOption.includes('+');
        });
      }
      return [... new Set(options)];
    }
    renderSelectedFilters() {
      this.querySelectorAll('.js-selected-filter').forEach(filter => filter.remove());
      const orderedFilters = this.props.filterOrder.split(',');
      for (const filter of orderedFilters) {
        let selectedOptions = [];
        if(filter === 'filter.v.option.size') {
          if (this.state.selectedFilters[filter]?.bra) {
            selectedOptions = this.filterBraSizeOptions(this.state.selectedFilters[filter].bra.options);
          }
          for (let sizeFilter in this.state.selectedFilters[filter]) {
            if (sizeFilter !== 'bra') {
              selectedOptions = selectedOptions.concat(this.state.selectedFilters[filter][sizeFilter].options);
            }
          }
        } else {
          selectedOptions = this.state.selectedFilters[filter]?.options;
        }
        if (selectedOptions) {
          selectedOptions = [... new Set(selectedOptions.map((opt) => opt.trim()))];
          for (const option of selectedOptions) {
            const selectedFilterTemplate = this.querySelector('.js-template-selected-filter').content.cloneNode(true);
            let filterText = decodeURIComponent(option);
            if (filterText.includes(':')) {
              filterText = filterText.split(':')[1];
            }
            selectedFilterTemplate.querySelector('.js-selected-filter-text').textContent = filterText;
            selectedFilterTemplate.querySelector('.js-selected-filter').dataset.paramName = filter;
            selectedFilterTemplate.querySelector('.js-selected-filter').dataset.value = option;
            this.querySelector('.js-selected-filters').append(selectedFilterTemplate);
          }
        }
      }
    }

    updateCount() {
      let totalCount = 0;
      let sizeFiltersCount = 0;
      for (let filter in this.state.selectedFilters) {
        if(filter === 'filter.v.option.size') {
          let filterOptions = [];
          if (this.state.selectedFilters[filter]?.bra) {
            filterOptions = this.filterBraSizeOptions(this.state.selectedFilters[filter].bra.options);
          }
          for (let sizeFilter in this.state.selectedFilters[filter]) {
            if (sizeFilter !== 'bra') {
              filterOptions = filterOptions.concat(this.state.selectedFilters[filter][sizeFilter].options);
            }
          }
          filterOptions = [... new Set(filterOptions)];
          totalCount = totalCount + filterOptions.length;
          sizeFiltersCount = filterOptions.length;
        } else {
          if (this.state.selectedFilters[filter].options.length > 0) {
            totalCount = totalCount + this.state.selectedFilters[filter].count;
          }
        }
        // Update individual filter count for main filter bar
        let filterCount;
        let filterLabel;
        if(filter === 'filter.v.option.size') {
          filterCount = sizeFiltersCount;
          filterLabel =  this.querySelector('.js-filter-label[data-type="Size"]');
        } else {
          filterCount = this.state.selectedFilters[filter].count;
          filterLabel =  this.querySelector(`.js-filter-label[data-type="${this.state.selectedFilters[filter].type}"]`);
        }
        filterLabel.querySelector('.js-filter-count').innerHTML = `${filterCount === 0 ? '' : filterCount}`
        if (filterCount > 0) {
          filterLabel.classList.add('filters-label--active');
        } else {
          filterLabel.classList.remove('filters-label--active');
        }
      }
      this.querySelector('.js-filters-label-count').innerHTML = `(${totalCount})`;
      return totalCount;
    }
    toggleDrawer() {
      this.querySelector('.js-filters-modal').classList.toggle('filters-modal--active');
      this.querySelector('.js-filters-modal-overlay').classList.toggle('filters-modal-overlay--active');
    }
    getParams() {
      let params = this.getFilterParams();
      if (this.state.sortBy) {
        params = `${params}&sort_by=${this.state.sortBy}`
      }
      return params;
    }
    getFilterParams() {
      let params = '';
      if (this.state.selectedFilters) {
        let index = 0;
        for (let filter in this.state.selectedFilters) {
          if(filter === 'filter.v.option.size') {
            let sizefilterOptions = '';
            let filterOptions = [];
            for (let sizeFilter in this.state.selectedFilters[filter]) {
              const opts = this.state.selectedFilters[filter][sizeFilter].options;
              filterOptions = filterOptions.concat(opts);
              sizefilterOptions += `${sizeFilter}=${opts}&`
            }
            filterOptions = [... new Set(filterOptions)];
            if (filterOptions.length > 0) {
              params = `${params}${index > 0 ? '&' : ''}${filter}=${filterOptions.toString()}`;
              index++;
            }
            params = `${params}&${sizefilterOptions.slice(0, -1)}`
          } else {
            if (this.state.selectedFilters[filter].options.length > 0) {
              params = `${params}${index > 0 ? '&' : ''}${filter}=${this.state.selectedFilters[filter].options.toString()}`;
              index++;
            }
          }
        }
      }
      return params;
    }
    clearFilters() {
      this.state.selectedFilters = {};
      this.querySelectorAll('.js-filter-selected-items').forEach(selectedItems => {
        selectedItems.innerHTML = '';
      });
      this.querySelectorAll('.js-filter-value-input').forEach(value => {
        value.checked = false;
      });
      this.querySelectorAll('.js-filter-count').forEach(count => {
        count.innerHTML = '';
      });
      this.querySelectorAll('.js-filter-label').forEach(label => {
        label.classList.remove('filters-label--active');
      });
      this.querySelectorAll('component-collection-filter').forEach(filter => {
        filter.clearFilter();
      });
      document.dispatchEvent(new CustomEvent('clearFilters'));
    }
    sendSortByGTMData() {
      window.sendGTMData && window.sendGTMData({
        event: 'plp_sort_click',
        collection_type: window.theme?.collection?.title || '',
        sort_button_applied: this.state.sortBy === '' ? false : true,
        sort_button_value: this.state.sortBy
      });
    }
    sendFilterApplyGTMData() {
      const selectedFilters = Object.values(this.state.selectedFilters).filter(item => {
        if (Array.isArray(item)) {
          return item.options.length > 0;
        } else {
          return Object.keys(item).length > 0;
        }

       });
      if (selectedFilters.length && window.sendGTMData) {
        const data = {
          event: 'plp_filter_click',
          collection_type: window.theme?.collection?.title || '',
          filter_query: this.getFilterParams(),
          filter_button_clicked: this.state.filterLabelClicked,
          source: 'filter_drawer'
        };
        selectedFilters.forEach(filter => {
          if (filter?.type === undefined) {
            let opts = '';
            for (let sizeFilter in filter) {
              opts += filter[sizeFilter].options.map(opt => opt.split(':').pop()).join(',');
            }
            data['filter_size'] = opts;
          } else {
            data[`filter_${filter.type.toLowerCase()}`] = filter.options.map(opt => opt.split(':').pop()).join(',');
          }
        });
        window.sendGTMData(data);
      }
      this.state.filterLabelClicked = '';
    }
  });
}

// Filter item in modal
if (!customElements.get('component-collection-filter')) {
  customElements.define('component-collection-filter', class CollectionFilter extends HTMLElement {
    constructor() {
      super();
      this.state = {
        activeValues: {}
      }
      this.dom = {
        parentComponent: this.closest('component-collection-filters'),
      }
      this.props = {
        type: this.dataset.type,
        paramName: this.dataset.paramName,
        values: this.dataset.values,
        autoApplyBottomStyles: this.dataset.autoApplyBottomStyles,
        autoApplyTopStyles: this.dataset.autoApplyTopStyles
      }
    }
    clearFilter() {
      this.state.activeValues = {};
    }
    async connectedCallback() {
      // For color filter, add swatches
      this.addColors();
      // On filter load, update parent state from checked values
      this.loadFiltersFromUrl();
      this.handleFilterValueChange();
      this.querySelectorAll('.js-filter-accordion-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.querySelector('.js-filter-values').classList.toggle('hidden');
          this.querySelector('.js-filter-accordion-arrow').classList.toggle('filter-accordion-arrow-flip');
        });
      });

      //bloomreach filter
      document.addEventListener("quiz_bra_blem_filter", (event) => {
        const component = this.dom.parentComponent;
        const detail = event.detail;
        if (!detail || !component) return;

        const { band_size, cup_size, bra_size, brablems, brablems_count } = detail;

        const brablemsArray = brablems ? brablems.split(",") : [];
        const brablemsMap = {
          moreLift: "More Lift",
          moreSupport: "More Support",
          minimizing: "Minimizing",
          strapStayPut: "Straps That Stay Put",
          backSmoothing: "Back and Armhole Smoothing",
          breathable: "Breathable",
          gapingCups: "Gaping Cups",
          nippleCoverage: "Nipple Coverage",
        };

        const replacedBrablemsArray = brablemsArray.map((item) => brablemsMap[item] || item);
        const formattedBrablems = replacedBrablemsArray.map((str) => {
          // Primeiro aplica a transformação normal
          let formatted = str.replace(/([a-z])([A-Z])/g, "$1 $2")
            .split(" ")
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");
          
          // Corrige especificamente o "And" para "and"
          formatted = formatted.replace(/\bAnd\b/g, "and");
          
          return formatted;
        });

        if (band_size && cup_size) {
          component.state.selectedFilters["filter.v.option.size"] =
          component.state.selectedFilters["filter.v.option.size"] || {};
          const baseSize = bra_size || `${band_size}${cup_size}`;
          const sizeOptions = [baseSize];

          const alphaSize = getMappedAlphaSize(baseSize);
          if (alphaSize && !sizeOptions.includes(alphaSize)) {
            sizeOptions.push(encodeURIComponent(alphaSize));
          }

          const formFitSize = getMappedFormfitSize(baseSize);
          if (formFitSize && !sizeOptions.includes(formFitSize)) {
            sizeOptions.push(encodeURIComponent(formFitSize));
          }

          component.state.selectedFilters["filter.v.option.size"]["bra"] = {
            options: sizeOptions,
            type: "Size",
            count: sizeOptions.length,
          };
        }

        if (formattedBrablems.length > 0) {
          component.state.selectedFilters["filter.p.m.filters.bra_blem"] = {
            options: formattedBrablems,
            type: "Bra-Blem",
            count: formattedBrablems.length,
          };
        } else if (brablems_count === 0) {
          delete component.state.selectedFilters["filter.p.m.filters.bra_blem"];
        }

        component.renderSelectedFilters();
        component.filterProducts(false);
      });

      //bloomreach filter
      document.addEventListener("button_quiz_apply_filter", (event) => {
        const component = this.dom.parentComponent;
        const detail = event.detail;
        if (!detail || !component) return;

        const { band_size, cup_size, bra_size, brablems, brablems_count } = detail;

        const brablemsArray = brablems ? brablems.split(",") : [];
        const brablemsMap = {
          moreLift: "More Lift",
          moreSupport: "More Support",
          minimizing: "Minimizing",
          strapStayPut: "Straps That Stay Put",
          backSmoothing: "Back and Armhole Smoothing",
          breathable: "Breathable",
          gapingCups: "Gaping Cups",
          nippleCoverage: "Nipple Coverage",
        };

        const replacedBrablemsArray = brablemsArray.map((item) => brablemsMap[item] || item);
        const formattedBrablems = replacedBrablemsArray.map((str) => {
          // Primeiro aplica a transformação normal
          let formatted = str.replace(/([a-z])([A-Z])/g, "$1 $2")
            .split(" ")
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");
          
          // Corrige especificamente o "And" para "and"
          formatted = formatted.replace(/\bAnd\b/g, "and");
          
          return formatted;
        });

        if (band_size && cup_size) {
          component.state.selectedFilters["filter.v.option.size"] =
          component.state.selectedFilters["filter.v.option.size"] || {};
          const baseSize = bra_size || `${band_size}${cup_size}`;
          const sizeOptions = [baseSize];

          const alphaSize = getMappedAlphaSize(baseSize);
          if (alphaSize && !sizeOptions.includes(alphaSize)) {
            sizeOptions.push(encodeURIComponent(alphaSize));
          }

          const formFitSize = getMappedFormfitSize(baseSize);
          if (formFitSize && !sizeOptions.includes(formFitSize)) {
            sizeOptions.push(encodeURIComponent(formFitSize));
          }

          component.state.selectedFilters["filter.v.option.size"]["bra"] = {
            options: sizeOptions,
            type: "Size",
            count: sizeOptions.length,
          };
        }

        if (formattedBrablems.length > 0) {
          component.state.selectedFilters["filter.p.m.filters.bra_blem"] = {
            options: formattedBrablems,
            type: "Bra-Blem",
            count: formattedBrablems.length,
          };
        } else if (brablems_count === 0) {
          delete component.state.selectedFilters["filter.p.m.filters.bra_blem"];
        }

        component.renderSelectedFilters();
        component.filterProducts(false);
      });
    }
    loadFiltersFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.size > 0) {
        for (const [key, value] of urlParams.entries()) {
          let filterType = null;
          let group  = null;
          let selectedOptions = value.split(',');
          let options = {};
          let paramName = key;
          let count = null;

          if (key === 'underwear') {
            filterType = 'Size';
            group = 'underwear';
            options['Size'] = selectedOptions;
            paramName = 'filter.v.option.size';
          }
          if (key === 'top') {
            filterType = 'Size';
            group = 'top';
            options['Size'] = selectedOptions;
            paramName = 'filter.v.option.size';
          }
          if (key === 'bottom') {
            filterType = 'Size';
            group = 'bottom';
            options['Size'] = selectedOptions;
            paramName = 'filter.v.option.size';
          }
          if (key === 'filter.v.option.size') {
            filterType = 'Size';
            group = 'bra';
            count = selectedOptions.length;
            options['Size'] = [selectedOptions.shift()];
            options['alphaSize'] = selectedOptions.filter((size) => !size.includes('+'));
            options['formFitSizes'] = selectedOptions.filter((size) => size.includes('+'));
          }
          if (key === 'filter.p.tag') {
            filterType = 'Style';
            options['Style'] = selectedOptions;
          }
          if (key === 'filter.p.m.filter.color_family') {
            filterType = 'Color';
            options['Color'] = selectedOptions;
          }
          if (key === 'filter.p.m.filters.bra_blem') {
            filterType = 'Bra-Blem';
            options['Bra-Blem'] = selectedOptions;
          }
          if (key === 'filter.p.m.filters.bra-coverage') {
            filterType = 'Coverage';
            options['Coverage'] = selectedOptions;
          }
          if (key === 'filter.p.m.filters.collection') {
            filterType = 'Collection';
            options['Collection'] = selectedOptions;
          }
          if (key === 'filter.p.m.filters.fabric') {
            filterType = 'Fabric';
            options['Fabric'] = selectedOptions;
          }
          if (key === 'filter.p.m.filters.type') {
            filterType = 'Type';
            options['Type'] = selectedOptions;
          }

          if (filterType) {
            this.dispatchEvent(new CustomEvent('update-state', {
              bubbles: true,
              detail: {
                type: filterType,
                paramName,
                options,
                group,
                count: count || selectedOptions.length,
                init: true
              }
            }));

            if (key === 'filter.v.option.size') {
              this.checkSelectedValueIfNotChecked(options['Size'][0].slice(0, 2), 'band');
              this.checkSelectedValueIfNotChecked(options['Size'][0].slice(2), 'cup');
              this.updateSelectedItemsText(options['Size'], filterType);
            } else {
              this.checkSelectedValueIfNotChecked(selectedOptions[0], group);
              this.updateSelectedItemsText(selectedOptions, filterType);
            }
          }
        }
      }
    }
    handleFilterValueChange() {
      this.querySelectorAll('.js-filter-value-input').forEach(value => {
        if (value.checked) {
          this.state.activeValues[value.name] = value;
          if (value.name === 'band') {
            this.updateCupSizes(value.value);
          }
        }
        value.addEventListener('click', (event) => {
          // For size radio buttons, allow click to deselect option
          if (value.dataset.type == 'size') {
            // If product size is selected, also select the product type
            if (value === this.state.activeValues[value.name]) {
              this.resetFilterGroup(value.name);
              this.state.activeValues[value.name] = null;
            } else {
              this.state.activeValues[value.name] = value;
            }
            // Dynamically update cup sizes based on band value
            if (this.state.activeValues[value.name] && value.name == 'band') {
              this.updateCupSizes(this.state.activeValues[value.name].value);
            }
            if (!this.state.activeValues[value.name] && value.name == 'band') {
              this.resetCupSizes();
            }
          }
          this.updateFilterState(event);
        });
      });
    }
    updateCupSizes(bandSize) {
      this.querySelectorAll('.js-cup-sizes .js-filter-value-container').forEach(cup => {
        const cupValue = cup.querySelector('.js-filter-value-input').value;
        const isActive = cup.querySelector('.js-filter-value-input').checked;
        if (this.props.values.includes(`${bandSize}${cupValue}`)) {
          cup.classList.remove('hidden');
        } else {
          cup.classList.add('hidden');
          if (isActive) {
            this.resetFilterGroup(cup.querySelector('.js-filter-value-input').name);
          }
        }
      });
    }
    resetCupSizes() {
      this.querySelectorAll('.js-cup-sizes .js-filter-value-container').forEach(cup => {
        cup.classList.remove('hidden');
      });
    }
    resetFilterGroup(name) {
      this.querySelectorAll(`.js-filter-value-input[name=${name}]`).forEach(value => value.checked = false);
    }
    async updateFilterState(event) {
      // Prepare object from filter input values, then dispatch event to update parent component
      let selectedOptions = {};
      let count = 0;
      let group = undefined;
      selectedOptions[this.props.type] = [];
      if (this.props.type === 'Size') {
        if (this.querySelector('.js-band-sizes') && this.querySelector('.js-cup-sizes')) {
          let bandSize, cupSize;
          if (this.querySelector('input[name="band"]:checked')) {
            bandSize = this.querySelector('input[name="band"]:checked').value;
          }
          if (this.querySelector('input[name="cup"]:checked')) {
            cupSize = this.querySelector('input[name="cup"]:checked').value;
          }
          if (bandSize && cupSize) {
            selectedOptions[this.props.type]['bra'] = [`${bandSize}${cupSize}`];
            // Always include alpha size that band/cup size is mapped to
            if (this.dom.parentComponent.props.autoApplyAlphaSize) {
              selectedOptions["alphaSize"] = [];
              const alphaSize = getMappedAlphaSize(`${bandSize}${cupSize}`);
              if (alphaSize) {
                selectedOptions["alphaSize"].push(alphaSize);
              }
              const formFitSizes = await this.getFormFitSizes(`${bandSize}${cupSize}`);
              if (formFitSizes) {
                selectedOptions["formFitSizes"] = formFitSizes;
              }
            }
            count++;
            group = 'bra';
          }
        }
        if (this.querySelector('.js-other-sizes') && event.currentTarget.dataset.group === 'other') {
          let otherSize;
          group = 'other';
          if (this.querySelector('input[name="other"]:checked')) {
            otherSize = this.querySelector('input[name="other"]:checked').value;
          }
          if (otherSize) {
            selectedOptions[this.props.type]['other'] = [`${otherSize}`];
            count++;
            // Include form fit sizes that alpha size is mapped to
            const formFitSizes = await this.getFormFitSizes(otherSize);
            if (formFitSizes) {
              selectedOptions["formFitSizes"] = formFitSizes;
            }
          }
        }
        if (this.querySelector('.js-underwear-sizes') && event.currentTarget.dataset.group === 'underwear') {
          let underwearSize;
          group = 'underwear';
          if (this.querySelector('input[name="underwear"]:checked')) {
            underwearSize = this.querySelector('input[name="underwear"]:checked').value;
          }
          if (underwearSize) {
            selectedOptions[this.props.type]['underwear'] = [`${underwearSize}`];
            count++;
          }
        }
        if (this.querySelector('.js-top-sizes') && event.currentTarget.dataset.group === 'top') {
          let topSize;
          group = 'top';
          if (this.querySelector('input[name="top"]:checked')) {
            topSize = this.querySelector('input[name="top"]:checked').value;
          }
          if (topSize) {
            selectedOptions[this.props.type]['top'] = [`${topSize}`];
            count++;
          }
        }
        if (this.querySelector('.js-bottom-sizes') && event.currentTarget.dataset.group === 'bottom') {
          let bottomSize;
          group = 'bottom';
          if (this.querySelector('input[name="bottom"]:checked')) {
            bottomSize = this.querySelector('input[name="bottom"]:checked').value;
          }
          if (bottomSize) {
            selectedOptions[this.props.type]['bottom'] = [`${bottomSize}`];
            count++;
          }
        }
      } else {
        const options = this.querySelectorAll('input:checked');
        for (const option of options) {
          selectedOptions[this.props.type].push(option.value);
          count++;
        }
      }
      if (this.props.type === 'Size' && selectedOptions[this.props.type] && group) {
        if (group !== 'bra') {
          delete selectedOptions['alphaSize'];
          delete selectedOptions['formFitSizes'];
        }
        selectedOptions[this.props.type] = selectedOptions[this.props.type][group] || [];
        count = selectedOptions[this.props.type].length;
      }

      this.dispatchEvent(new CustomEvent('update-state', {
        bubbles: true,
        detail: {
          type: this.props.type,
          paramName: this.props.paramName,
          options: selectedOptions,
          group,
          count,
          init: false
        }
      }));
      this.updateSelectedItemsText(selectedOptions[this.props.type], this.props.type);
      // Select size product types
      if (this.props.type === 'Size') {
        let typesToSelect = [];
        let typesToUnselect = [];
        // Get active filters types to select
        for (const activeValue in this.state.activeValues) {
          if (this.state.activeValues[activeValue]) {
            typesToSelect = typesToSelect.concat(this.state.activeValues[activeValue].dataset.productTypes.split(','));
          }
        }
        // Get filter types to unselecte
        if (!event.currentTarget.checked) {
          const uncheckedTypes = event.currentTarget.dataset.productTypes.split(',');
          typesToUnselect = uncheckedTypes.filter((prdType) => !typesToSelect.includes(prdType));
        }


        const productTypes = document.querySelectorAll('input[name="Type"]');
        if(typesToSelect) {
          const toSelect = [... new Set(typesToSelect)].map((typeToSelect) => typeToSelect.toLowerCase().replaceAll(' ', '-'));
          productTypes.forEach((prodType) => {
            const val = prodType.value.toLowerCase().replaceAll(' ', '-');
            if (toSelect.includes(val) && !prodType.checked) {
              prodType.click();
            }
          });
        }

        if (typesToUnselect) {
          const toUnselect = [... new Set(typesToUnselect)].map((typeToUnselect) => typeToUnselect.toLowerCase().replaceAll(' ', '-'));
          productTypes.forEach((prodType) => {
            const val = prodType.value.toLowerCase().replaceAll(' ', '-');
            if (toUnselect.includes(val) && prodType.checked) {
              prodType.click();
            }
          });
        }

        // Auto apply bottom styles on bottom size select
        if (this.props.autoApplyBottomStyles === 'true') {
          const bottomStyles = document.querySelectorAll('input[name="bottom-style"]');
          bottomStyles.forEach((bottomStyle) => {
            if (this.state.activeValues?.bottom && !bottomStyle.checked || !this.state.activeValues?.bottom && bottomStyle.checked) {
              bottomStyle.click();
            }
          });
        }

        // Auto apply top styles on top size select
        if (this.props.autoApplyTopStyles === 'true') {
          const topStyles = document.querySelectorAll('input[name="top-style"]');
          topStyles.forEach((topStyle) => {
            if (this.state.activeValues?.top && !topStyle.checked || !this.state.activeValues?.top && topStyle.checked) {
              topStyle.click();
            }
          });
        }
      }
    }
    async getFormFitSizes(alphaSize) {
      if (this.dom.parentComponent.props.autoApplyFormFitSize) {
        const sizes = [];
        let formFitSize = getMappedFormfitSize(alphaSize);
        if (formFitSize) {
          const encodedSize = encodeURIComponent(formFitSize);
          sizes.push(encodedSize);
        }
        return sizes;
      }
    }
    updateSelectedItemsText(options, filterType) {
      const selecteOption = [... new Set(options)]
      const filterSection = this.querySelector(`component-collection-filter[data-type="${filterType}"] .js-filter-selected-items`);
      if (selecteOption && filterSection) {
        filterSection.textContent = '';
        selecteOption.forEach((item, index) => {
          const itemSpan = document.createElement('span');
          let itemText = item;
          if (itemText.includes(':')) {
            itemText = itemText.split(':')[1]
          }
          itemSpan.innerHTML = `${itemText}${index !== selecteOption.length - 1 ? ', ' : ''}`;
          filterSection.append(itemSpan);
        });
      }
    }
    addColors() {
      this.querySelectorAll('.js-filter-color').forEach(colorContainer => {
        const colorValue = colorContainer.dataset.color;
        const colorLabel = colorContainer.querySelector('.js-color-value-label');
        if (window.theme.colors[colorValue]) {
          if (window.theme.colors[colorValue].image) {
            colorLabel.style.setProperty('--swatch-image', `url(${window.theme.colors[colorValue].image}`);
          }
          colorLabel.style.setProperty('--swatch-color', window.theme.colors[colorValue].color);
          colorLabel.style.setProperty('--swatch-border-color', '#fff');
        }
      });
    }
    uncheckSelectedValue(value) {
      this.querySelectorAll(`.js-filter-value-input`).forEach(el => {
        if (el && value.includes(el.value)) {
          el.checked = false;
        }
      });
    }
    checkSelectedValueIfNotChecked(value, group) {
      let inputEl = this.querySelector(`.js-filter-value-input[value="${value}" i]`);
      if(group) {
        inputEl = this.querySelector(`.js-filter-value-input[data-group="${group}"][value="${value}" i]`);
      }
      if(inputEl && !inputEl.checked) {
        inputEl.checked = true;
      }
    }
  });
}

// Selected filter shown below filter bar
if (!customElements.get('component-selected-filter')) {
  customElements.define('component-selected-filter', class CollectionSelectedFilter extends HTMLElement {
    constructor() {
      super();
      this.props = {
        paramName: this.dataset.paramName,
        value: this.dataset.value
      }
    }
    connectedCallback() {
      this.querySelector('.js-remove-filter').addEventListener('click', () => {
        this.removeFilter();
      });
    }
    removeFilter() {
      this.dispatchEvent(new CustomEvent('remove-filter', {
        bubbles: true,
        detail: {
          type: this.props.type,
          paramName: this.props.paramName,
          value: this.props.value
        }
      }));
      this.remove();
    }
  })
}
